import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const client = useQueryClient();
  const taggingFixed = getTagging('portability', 'fixed', client);

  const { trackView } = useTracking({
    event: ['checkout_step4.3'],
    event_label: 'carrier information',
    opts: taggingFixed.opts,
    cartProduct: taggingFixed.trackingProduct,
    pageProduct: taggingFixed?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackView(trackView);
  return null;
};

const TaggingPortabilityOperatorsCard = withAnimationDelay()(TaggingComponent);

export default TaggingPortabilityOperatorsCard;
